/**
 * Wraps an error with a custom message prefix
 */
export const wrapError = (message: string, error: any): Error => {
  return new Error(`${message}: ${error.message || error}`);
};

/**
 * Higher-order function that wraps an async operation with loading state management
 */
export const createWithLoading = (setIsLoading: (loading: boolean) => void) => {
  return async <T>(fn: () => Promise<T>): Promise<T> => {
    setIsLoading(true);
    try {
      return await fn();
    } finally {
      setIsLoading(false);
    }
  };
};
